import _ from "lodash";
import React, { useEffect } from "react";
import MuiRadio from "@mui/material/Radio";
import AnswerLong from "../AnswerLong";
import { shuffle, sorter } from "../../../services/commons";
import QuestionPreview from "../QuestionPreview";
import useStyles from "./styles";
import { useSelector } from "react-redux";
import {
  THEME_WALMART_CLASSIC,
  THEME_GLOBAL_TECHNOLOGY,
  THEME_SAM_CLUB,
  OTHER,
  NONE,
  renderOtherByLang,
} from "../../constants";
import { extractContent } from "../../../services/commons";
import { shortAnswerMaxCount } from "../../../services/constants";

const VALUE_PREFIX = "Value_";

export function sortChoices(choices, random, asc) {
  if (asc === true) {
    choices.sort(sorter("label", 1));
    const indexOfOther = choices.findIndex((item) => item.value === OTHER);
    const indexOfNone = choices.findIndex((item) => item.value === NONE);
    if (indexOfOther !== -1) choices.push(choices.splice(indexOfOther, 1)[0]);
    if (indexOfNone !== -1) {
      choices.push(choices.splice(indexOfNone, 1)[0]);
    }
  } else if (random === true) {
    return shuffle(choices);
  }
  return choices;
}

const AnswerSingleSelect = (props) => {
  const styles = useStyles(props);
  const [selected, setSelected] = React.useState(props.value);
  const [otherValue, setOtherValue] = React.useState(props.OtherValue);
  const [choices, setChoices] = React.useState(() =>
    sortChoices(_.cloneDeep(props.choices), props.random, props.asc)
  );

  let surveyTheme = THEME_WALMART_CLASSIC;
  const { currentSurveyId, data } = useSelector((state) => state.survey);
  if (
    currentSurveyId &&
    data[currentSurveyId] &&
    data[currentSurveyId].thirdPartySettings
  ) {
    const { theme } = data[currentSurveyId].thirdPartySettings;
    if (theme) {
      surveyTheme = theme;
    }
  }

  useEffect(() => {
    setChoices(
      sortChoices(_.cloneDeep(props.choices), props.random, props.asc)
    );
  }, [props.random, props.asc]);

  useEffect(() => {
    //show options based on previous question dynamic options
    if (props.choicesType === "dynamic") {
      setChoices(
        sortChoices(_.cloneDeep(props.choices), props.random, props.asc)
      );
    }
  }, [props.choices]);

  useEffect(() => {
    if (props.value === OTHER) {
      setSelected(OTHER);
    } else if (props.value === NONE) {
      setSelected(NONE);
    } else if (props.type === "range") {
      setSelected(props.value);
    } else {
      setSelected(props.value ? `${VALUE_PREFIX}${props.value}` : "");
    }
  }, [props.value]);

  useEffect(() => {
    setOtherValue(props.otherValue);
  }, [props.otherValue]);

  useEffect(() => {
    setChoices(
      sortChoices(_.cloneDeep(props.choices), props.random, props.asc)
    );
  }, [props.choices]);

  const handleChange = (value) => {
    setSelected(value);
    props.handleChange(value);
  };

  const handleOtherValueChange = (val) => {
    if (
      val &&
      typeof val === "string" &&
      val.length > 0 &&
      val.trim().length == 0
    ) {
      val = "";
    }
    props.handleOtherOptionSelection(val);
    setOtherValue(val);
  };

  const getChoices = () => {
    if (props.choices && props.choices.length > 0) {
      // if (choices && choices.length > 0) {
      return choices
        .filter((item) => item.shouldRenderChoice !== false)
        .map((item) => {
          if (
            item.value !== OTHER &&
            item.value !== NONE &&
            props.type !== "range" &&
            !item.value.includes(VALUE_PREFIX)
          ) {
            item.value = `${VALUE_PREFIX}${item.value}`;
          } else if (props.type === "range") {
            item.value = `${item.value}`;
          }
          return item;
        });
      // return transformedChoices;
      // }
      // else {
      //   if (selected) {
      //     if (
      //       selected != OTHER &&
      //       props.choices.filter((choice) => choice.value === selected)
      //         .length === 0
      //     ) {
      //       setSelected(null);
      //       props.handleChange();
      //     }
      //   }
      //   return sortChoices(
      //     _.cloneDeep(props.choices),
      //     selected ? false : props.random,
      //     props.asc
      //   );
      // }
    }
    return [];
  };

  const renderChoice = (value, label, classes, shouldHaveDoubleColumn) => {
    return (
      <div
        className={`${styles.itemGap} ${
          shouldHaveDoubleColumn ? styles.halfColumn : styles.radio
        }`}
        key={value}
      >
        <MuiRadio
          checked={selected === value}
          onChange={() => handleChange(value)}
          value={value}
          classes={{
            root:
              selected === value
                ? classes.elementStyle
                : classes.elementStyleNotSelected,
            checked:
              surveyTheme === THEME_GLOBAL_TECHNOLOGY
                ? classes.globalTech
                : surveyTheme === THEME_SAM_CLUB
                ? classes.samClub
                : classes.walmartClassic,
          }}
          inputProps={{ "aria-describedby": `${props.questionId}-error` }}
          id={`${props.questionId}-${label.replace(/\s+/g, "")}`}
          name={extractContent(props.question.replace(/\s+/g, ""))}
        />

        <div
          className={styles.radioText}
          onClick={() => handleChange(value)}
          data-testid="handle-change-test-id"
        >
          {label && (
            <label
              htmlFor={`${props.questionId}-${label.replace(/\s+/g, "")}`}
              className={styles.label}
            >
              {label}
            </label>
          )}
        </div>
      </div>
    );
  };

  let value;
  if (otherValue && otherValue.length > shortAnswerMaxCount) {
    value = otherValue.substring(0, shortAnswerMaxCount);
  } else {
    value = otherValue;
  }

  const isMobile = window.innerWidth < 768;
  const shouldHaveDoubleColumn =
    getChoices() && getChoices().length > 10 && !isMobile;
  return (
    <div>
      <fieldset aria-required={props.required}>
        {!props.ptl && (
          <legend>
            <QuestionPreview
              question={props.question}
              required={props.required}
              helperText={props.helperText}
              formattingType={
                props.formattingType ? props.formattingType : null
              }
            />
          </legend>
        )}
        <div
          className={`${
            shouldHaveDoubleColumn ? styles.halfColumnWrapper : styles.radios
          }`}
          role="radiogroup"
          // aria-label={${props.question}, ${props.description}}
        >
          {getChoices()
            .filter(({ value }) => value !== NONE)
            .map(({ value, label }) =>
              renderChoice(value, label, styles, shouldHaveDoubleColumn)
            )}
          {props.other === true &&
            props.choicesType === "dynamic" &&
            renderChoice(
              OTHER,
              renderOtherByLang(props.currentLang),
              styles,
              shouldHaveDoubleColumn
            )}
          {selected === OTHER && (
            <div className={shouldHaveDoubleColumn ? styles.other : ""}>
              <AnswerLong
                currentTheme={props.currentTheme}
                question=""
                required={false}
                handleChange={handleOtherValueChange}
                value={value ? value : ""}
                maxChar={shortAnswerMaxCount}
              />
            </div>
          )}
          {getChoices()
            .filter(({ value }) => value === NONE)
            .map(({ value, label }) =>
              renderChoice(value, label, styles, shouldHaveDoubleColumn)
            )}
        </div>
      </fieldset>
    </div>
  );
};

export default AnswerSingleSelect;
